// routes
import Router from './routes';
// theme

import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
// The style alone, not the chart barrel: that barrel imports react-apexcharts,
// which would otherwise travel in the entry bundle for every page.
import ChartStyle from './components/chart/ChartStyle';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <ProgressBarStyle />
            <ChartStyle />
            <ScrollToTop />
            <ErrorBoundary>
              <Router />
            </ErrorBoundary>
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
